import localForage from 'localforage';
import { persistReducer } from 'redux-persist';
import { createSelector } from '@reduxjs/toolkit';
import _ from '@lodash';
import { type RootState } from 'app/store';
import { type SampleWorkflowsState, type SampleWorkflowsActionTypes } from 'app/store/types';

const initialState: SampleWorkflowsState = {};

const sampleWorkflowsReducer = (state = initialState, action: SampleWorkflowsActionTypes) => {
	switch (action.type) {
		case 'GET_LICENSE_GROUP_DATA_SUCCESS': {
			const {
				licenseGroupId,
				data: { sampleWorkflows },
			} = action.payload;

			return {
				...state,
				[licenseGroupId]: {
					...state[licenseGroupId],
					...(sampleWorkflows && {
						byId: _.mapValues(sampleWorkflows, (sampleWorkflow) => ({
							...sampleWorkflow,
						})),
					}),
				},
			};
		}
		case 'LOGGED_OUT_USER':
		case 'PURGE_STATE':
			return initialState;
		default: {
			return state;
		}
	}
};

export default persistReducer(
	{
		key: 'sampleWorkflows',
		storage: localForage,
		whitelist: localStorage.getItem('persist') ? undefined : [],
	},
	sampleWorkflowsReducer,
);

// Selectors
export const getSampleWorkflowsById = ({ app: { selectedLicenseGroupId }, sampleWorkflows }: RootState) =>
	sampleWorkflows[selectedLicenseGroupId].byId;

export const getSampleWorkflows = createSelector([getSampleWorkflowsById], (sampleWorkflowsById) =>
	Object.values(sampleWorkflowsById),
);
